import { render, staticRenderFns } from "./CrewProfile.vue?vue&type=template&id=bd6c2644&scoped=true&"
import script from "./CrewProfile.vue?vue&type=script&lang=js&"
export * from "./CrewProfile.vue?vue&type=script&lang=js&"
import style0 from "./CrewProfile.vue?vue&type=style&index=0&id=bd6c2644&scoped=true&lang=css&"
import style1 from "./CrewProfile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6c2644",
  null
  
)

export default component.exports